import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=d1b0535c&scoped=true"
import script from "./shopDetail.vue?vue&type=script&lang=js"
export * from "./shopDetail.vue?vue&type=script&lang=js"
import style0 from "./shopDetail.vue?vue&type=style&index=0&id=d1b0535c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b0535c",
  null
  
)

export default component.exports